export enum CardBrandEnum {
  Mastercard = 'Mastercard',
  Visa = 'VISA',
}
